import { observable, computed, action } from 'mobx';
import Http from 'services/Http';

export class RequestLedgerSubCategory {
    id: number = 0;
    name: string = '';
    consolidationCategoryID: number = 0;
    payee: string = '';
    consolidationFrequency: string = '';

    requestCategorySettings: RequestCategoryLedgerRow[] = [];
}

export class RequestCategoryLedgerRow {
    requestLedgerSubCategoryID: number = 0;
    requestCategoryID: number = 0;
    isDefault: boolean = true;
    isVisible: boolean = true;
    sequence?: number = 1;
    defaultCost: number = 0;
}

export class RequestLedgerSubCategoriesStore {

    @observable subCategories: RequestLedgerSubCategory[] = [];

    @observable selectedSubCategory: RequestLedgerSubCategory = new RequestLedgerSubCategory();

    @action
    load(subCategories: RequestLedgerSubCategory[]) {
        if (subCategories) this.subCategories = subCategories;
    }

    @action
    async fetchAll() {
        const res = await Http.get<any>({
            url: 'SystemSettings/GetRequestLedgerSubCategories',
            waitMessage: 'Fetching request ledger category data, please wait...'
        });

        if (res.success) {
            this.load(res.requestLedgerSubCategories)
        }
    }

    @action
    resetSelectedSubCategory() {
        this.selectedSubCategory = new RequestLedgerSubCategory();
    }

    @action
    addRequestCategoryRow(ledgerSubCategoryID: number) {
        //add a blank RequestCategory row to the list
        const subCategory = this.lookup.get(ledgerSubCategoryID);
        if (!subCategory) return;

        const newRequestCategory = new RequestCategoryLedgerRow();
        newRequestCategory.requestLedgerSubCategoryID = ledgerSubCategoryID;
        subCategory.requestCategorySettings.push(newRequestCategory);
    }

    @action
    editRequestCategoryRow(rowRef: RequestCategoryLedgerRow) {
        const { row, subCategory } = this.getRequestCategoryLedgerRowByReference(rowRef);
        if (!row || !subCategory) return;

        //TODO: does this really need to happen here? maybe move to an Editor component?
    }

    @action
    deleteRequestCategoryRow(rowRef: RequestCategoryLedgerRow) {
        const { row, subCategory } = this.getRequestCategoryLedgerRowByReference(rowRef);
        if (!row || !subCategory) return;
    }

    @computed get all() {
        return this.subCategories;
    }

    private getRequestCategoryLedgerRowByReference(rowByReference: RequestCategoryLedgerRow) {
        const emptyResult = { row: RequestCategoryLedgerRow , subCategory: RequestCategoryLedgerRow };
        if (!rowByReference) return emptyResult;
        const subCategory = this.lookup.get(rowByReference.requestLedgerSubCategoryID);
        if (!subCategory) return emptyResult;

        const row: RequestCategoryLedgerRow | undefined = subCategory.requestCategorySettings.find(rc => rc === row);
        return { row, subCategory };
    }

    /**
     * Returns a dictionary of SubCategoryID -> SubCategory
     */
    @computed get lookup() {
        return new Map<number, RequestLedgerSubCategory>(this.subCategories.map(sc => [sc.id, sc]));
    }
}

export default new RequestLedgerSubCategoriesStore();